var map = {
	"./ilustrations/1 copy.png": "./src/assets/themes/default/ilustrations/1 copy.png",
	"./ilustrations/1.png": "./src/assets/themes/default/ilustrations/1.png",
	"./ilustrations/2 copy.png": "./src/assets/themes/default/ilustrations/2 copy.png",
	"./ilustrations/2.png": "./src/assets/themes/default/ilustrations/2.png",
	"./ilustrations/3.png": "./src/assets/themes/default/ilustrations/3.png",
	"./ilustrations/4.png": "./src/assets/themes/default/ilustrations/4.png",
	"./ilustrations/5.png": "./src/assets/themes/default/ilustrations/5.png",
	"./ilustrations/6.png": "./src/assets/themes/default/ilustrations/6.png",
	"./logo-login.png": "./src/assets/themes/default/logo-login.png",
	"./logo-sidebar.png": "./src/assets/themes/default/logo-sidebar.png",
	"./wa-background.png": "./src/assets/themes/default/wa-background.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/themes/default sync recursive ^\\.\\/.*$";